import Tickets from "./Tickets";
import TicketEdit from "./TicketEdit";

export default {
    list: Tickets,
    edit: TicketEdit,
    create: TicketEdit
};

